const LicensePlateStars = ({ width = 16, height = 16 }) => (
  <svg fill="none" viewBox="0 0 16 16" width={width} height={height}>
    <circle cx="8" cy="2" r="1" fill="#FFF200" />
    <circle cx="4" cy="3.5" r="1" fill="#FFF200" />
    <circle cx="2" cy="6" r="1" fill="#FFF200" />
    <circle cx="2" cy="10" r="1" fill="#FFF200" />
    <circle cx="4" cy="12.5" r="1" fill="#FFF200" />
    <circle cx="8" cy="14" r="1" fill="#FFF200" />
    <circle cx="12" cy="12.5" r="1" fill="#FFF200" />
    <circle cx="14" cy="10" r="1" fill="#FFF200" />
    <circle cx="14" cy="6" r="1" fill="#FFF200" />
    <circle cx="12" cy="3.5" r="1" fill="#FFF200" />
  </svg>
);

export default LicensePlateStars;
